import { Injectable } from '@angular/core'
import { ParseService } from '../../parse.service'

interface UetqEvent {
    event_category?: string
    event_label?: string
    event_value?: number
    revenue_value?: number
    currency?: 'USD'
}

declare global {
    interface Window {
        uetq?: unknown[]
    }
}

@Injectable({
    providedIn: 'root',
})
export class MicrosoftUetService {
    constructor(private parseService: ParseService) {}

    get uetq() {
        if (!window.uetq) {
            window.uetq = []
        }

        return window.uetq
    }

    sendPurchaseEvent(value: number) {
        try {
            if (document.location.host !== 'app.wisepelican.com') {
                return
            }

            const purchaseEvent: UetqEvent = {
                event_category: 'purchase',
                event_label: 'purchase',
                event_value: value,
                revenue_value: value,
                currency: 'USD',
            }

            this.uetq.push('event', 'purchase', purchaseEvent)
        } catch (err) {
            this.parseService.reportUIError(err, 'MicrosoftUetService.sendPurchaseEvent', JSON.stringify({ value }))
        }
    }

    sendRegistrationEvent() {
        try {
            const registrationEvent: UetqEvent = {
                event_category: 'registration',
                event_label: 'registration',
                event_value: 0,
            }

            if (!this.uetq) {
                throw new Error('this.uetq not found')
            }

            this.uetq.push('event', 'registration', registrationEvent)
        } catch (err) {
            this.parseService.reportUIError(err, 'MicrosoftUetService.sendRegistrationEvent', JSON.stringify({}))
        }
    }
}
